import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL, OperationType, ROUTE_PATH } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams, GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { InternshipListModel, InternshipListChartsModel } from 'common/models/page-models/internship/internship-list/form-model/internship-list-form-data.model';
import { cardStatsMetaModel } from 'common/models/page-models/internship/internship-list/form-model/internship-list-form-meta-model';
import { InternshipListListingModel, InternshipListGridPostParams } from 'common/models/page-models/internship/internship-list/grid-model/internship-list-grid-model';
import { StudentListGridParams } from 'common/models/page-models/studentprofile/gridmodel/studentprofile-grid.data.mdoel';


@Injectable({
    providedIn: 'root'
})
export class InternshipListDataService extends GridDataService<InternshipListListingModel, InternshipListModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.fetchReportData, http, ss);
    }

    createInstance(): InternshipListListingModel {
        return new InternshipListListingModel();
    }

    getDeleteUrl() {
        return '';
    }

    override getGridParams(param): GridPostParams {
        return new StudentListGridParams();
    }

    override transformDataModel(data: any[], param) {
        super.transformDataModel(data, param);
        data[param].forEach(element => {
            element.isKT = element.overallKtStatus === 0 ? 'No' : 'Yes';
        });
        return data;
    }

    override modifyGridPostParams(queryParams) {
        let payload = this.getGridParams(queryParams);
        // if (queryParams.transferData !== null) {
        //     payload['batch_search'] = queryParams.transferData.selectedBatch === null ? '' :  queryParams.transferData.selectedBatch;
        //     payload['region_search'] = queryParams.transferData.selectedRegion  === null ? '' :  queryParams.transferData.selectedRegion;
        //     payload['branch_search'] = queryParams.transferData.selectedBranch  === null ? '' :  queryParams.transferData.selectedBranch;
        //     payload['state_search'] = queryParams.transferData.selectedState  === null ? '' :  queryParams.transferData.selectedState;
        //     payload['gender_search'] = queryParams.transferData.selectedGender  === null ? '' :  queryParams.transferData.selectedGender;
        //     payload['status_search'] = queryParams.transferData.selectedStatus  === null ? '' :  queryParams.transferData.selectedStatus;
        //     payload['ktStatus'] = queryParams.transferData.selectedKT  === null ? '' :  queryParams.transferData.selectedKT;
        //     payload['scoreFilter'] = queryParams.transferData.selectedScore  === null ? '' :  queryParams.transferData.selectedScore;
        //     payload['uploadedFilter'] = queryParams.transferData.selectedUploadFilter  === null ? '' :  queryParams.transferData.selectedUploadFilter;
        //     payload['semFilter'] = queryParams.transferData.selectedSem  === null ? '' :  queryParams.transferData.selectedSem;
        // }
        return payload;
    }

    override async modifyMultiModel(model) {
        const chartsData = this.prepareInternshipChartsData(model[1]);
        this.createGridModel(model[0], new GridParams(), this.getDataParam()).then(gridData => {
            model.gridModel = gridData;
            model.gridModel.chartsData = chartsData;
            model['internshipCounts'] = model[1].details;
            model['cardCounts'] = this.getCardCounts(model[1].details);
        })
            .catch(e => {
            });
    }

    override getDataParam(): string {
        return 'details'
    }

    getCardCounts(internshipCountData: any){
        const totalInternship = new cardStatsMetaModel('Total Internships', parseInt(internshipCountData.totalInternship), null, null, null);
        const assigned = new cardStatsMetaModel('Assigned Students', parseInt(internshipCountData.totalAvailableAndAssignedStudent), ROUTE_PATH.intershipGrid, null, '0')
        const joined = new cardStatsMetaModel('Joined Students', parseInt(internshipCountData.totalJoinedStudent), ROUTE_PATH.intershipGrid, null, '1')
        const notJoined = new cardStatsMetaModel('Not Joined Students', parseInt(internshipCountData.totalNotJoinedStudent) ,ROUTE_PATH.intershipGrid, null, '2')
        const completed = new cardStatsMetaModel('Completed Students', parseInt(internshipCountData.totalCompletedStudent), ROUTE_PATH.intershipGrid, null, '3')
        const discontinued = new cardStatsMetaModel('Discontinued Students', parseInt(internshipCountData.totalDiscontinuedStudent), ROUTE_PATH.intershipGrid, null, '4')
        const cardArray = [totalInternship, assigned, joined, notJoined, completed, discontinued].map(obj => ({ ...obj }));
        return cardArray;
    }
    
    prepareInternshipChartsData(apiData) {
    //     const internshipdashboardCount = apiData['details'];
    //     const chartsModel = new InternshipListChartsModel();
    //     chartsModel.assignedStudentsChart = {
    //         chart: {
    //             type: "pie",
    //         },
    //         slicedOffset: 0,
    //         yAxis: {
    //             labels: {
    //                 enabled: false,
    //             },
    //         },
    //         xAxis: {
    //             labels: {
    //                 enabled: false,
    //             },
    //         },
    //         title: undefined,
    //         legend: {
    //             enabled: false,
    //         },
    //         tooltip: {
    //             enabled: false,
    //         },
    //         plotOptions: {
    //             pie: {
    //                 allowPointSelect: false,
    //                 cursor: "pointer",
    //                 dataLabels: {
    //                     enabled: false,
    //                 },
    //             },
    //             series: {
    //                 allowPointSelect: false,
    //                 animation: false,
    //                 states: {
    //                     hover: {
    //                         enabled: false,
    //                     },
    //                     inactive: {
    //                         opacity: 1,
    //                     },
    //                 },
    //             },
    //         },
    //         series: [
    //             {
    //                 innerSize: "80%",
    //                 data: [
    //                     {
    //                         name: "Invited",
    //                         y: parseInt(internshipdashboardCount.totalJoinedStudent),
    //                         color: "#C98331",
    //                         showInLegend: false,
    //                     },
    //                     {
    //                         name: "Not Invited",
    //                         y: parseInt(internshipdashboardCount.totalNotJoinedStudent),
    //                         color: "#E8D992",
    //                         showInLegend: false,
    //                     },
    //                 ],
    //             },
    //         ],
    //     };
    //     chartsModel.joinedStudentsChart = {
    //         chart: {
    //             type: "pie",
    //         },
    //         slicedOffset: 0,
    //         yAxis: {
    //             labels: {
    //                 enabled: false,
    //             },
    //         },
    //         xAxis: {
    //             labels: {
    //                 enabled: false,
    //             },
    //         },
    //         title: undefined,
    //         legend: {
    //             enabled: false,
    //         },
    //         tooltip: {
    //             enabled: false,
    //         },
    //         plotOptions: {
    //             pie: {
    //                 allowPointSelect: false,
    //                 cursor: "pointer",
    //                 dataLabels: {
    //                     enabled: false,
    //                 },
    //             },
    //             series: {
    //                 allowPointSelect: false,
    //                 animation: false,
    //                 states: {
    //                     hover: {
    //                         enabled: false,
    //                     },
    //                     inactive: {
    //                         opacity: 1,
    //                     },
    //                 },
    //             },
    //         },
    //         series: [
    //             {
    //                 innerSize: "80%",
    //                 data: [
    //                     {
    //                         name: "Invited",
    //                         y: parseInt(internshipdashboardCount.totalContinuedStudent),
    //                         color: "#FF834A",
    //                         showInLegend: false,
    //                     },
    //                     {
    //                         name: "Not Invited",
    //                         y: parseInt(
    //                             internshipdashboardCount.totalDiscontinuedStudent
    //                         ),
    //                         color: "#FFD851",
    //                         showInLegend: false,
    //                     },
    //                 ],
    //             },
    //         ],
    //     };

    //     chartsModel.continueddStudentsChart = {
    //         chart: {
    //             type: "pie",
    //         },
    //         slicedOffset: 0,
    //         yAxis: {
    //             labels: {
    //                 enabled: false,
    //             },
    //         },
    //         xAxis: {
    //             labels: {
    //                 enabled: false,
    //             },
    //         },
    //         title: undefined,
    //         legend: {
    //             enabled: false,
    //         },
    //         tooltip: {
    //             enabled: false,
    //         },
    //         plotOptions: {
    //             pie: {
    //                 allowPointSelect: false,
    //                 cursor: "pointer",
    //                 dataLabels: {
    //                     enabled: false,
    //                 },
    //             },
    //             series: {
    //                 allowPointSelect: false,
    //                 animation: false,
    //                 states: {
    //                     hover: {
    //                         enabled: false,
    //                     },
    //                     inactive: {
    //                         opacity: 1,
    //                     },
    //                 },
    //             },
    //         },
    //         series: [
    //             {
    //                 innerSize: "80%",
    //                 data: [
    //                     {
    //                         name: "Available",
    //                         y: parseInt(internshipdashboardCount.totalCompletedStudent),
    //                         color: "#528DB7",
    //                         showInLegend: false,
    //                     },
    //                     {
    //                         name: "Not Available",
    //                         y: parseInt(
    //                             internshipdashboardCount.totalDiscontinuedStudent
    //                         ),
    //                         color: "#79BCE2",
    //                         showInLegend: false,
    //                     },
    //                     {
    //                         name: "Not Responded",
    //                         y: parseInt(internshipdashboardCount.totalNotJoinedStudent),
    //                         color: "#B1B1B1",
    //                         showInLegend: false,
    //                     },
    //                 ],
    //             },
    //         ],
    //     };
    //     console.log("Chart", this)

    //     chartsModel.completedStudentsChart = {
    //         chart: {
    //             type: "pie",
    //         },
    //         slicedOffset: 0,
    //         yAxis: {
    //             labels: {
    //                 enabled: false,
    //             },
    //         },
    //         xAxis: {
    //             labels: {
    //                 enabled: false,
    //             },
    //         },
    //         title: undefined,
    //         legend: {
    //             enabled: false,
    //         },
    //         tooltip: {
    //             enabled: false,
    //         },
    //         plotOptions: {
    //             pie: {
    //                 allowPointSelect: false,
    //                 cursor: "pointer",
    //                 dataLabels: {
    //                     enabled: false,
    //                 },
    //             },
    //             series: {
    //                 allowPointSelect: false,
    //                 animation: false,
    //                 states: {
    //                     hover: {
    //                         enabled: false,
    //                     },
    //                     inactive: {
    //                         opacity: 1,
    //                     },
    //                 },
    //             },
    //         },
    //         series: [
    //             {
    //                 innerSize: "80%",
    //                 data: [
    //                     {
    //                         name: "Invited",
    //                         y: parseInt(internshipdashboardCount.totalCompletedStudent),
    //                         color: "#83BD75",
    //                         showInLegend: false,
    //                     },
    //                     {
    //                         name: "Not Invited",
    //                         y: parseInt(
    //                             internshipdashboardCount.totalNotCompletedStudent
    //                         ),
    //                         color: "#549274",
    //                         showInLegend: false,
    //                     },
    //                 ],
    //             },
    //         ],
    //     };
    //     console.log("API Response.........", apiData);
       // return [];
    }
}
